import React, { useEffect, useState } from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Status from "components/presentation/Status";


export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()

    let out;
    if (competitor?.cp_prev_wlt && competitor?.cp_prev_value) {
        out = <><SportCode discipline={mirs_discipline} entity='@WLT' code={competitor?.cp_prev_wlt} /> {competitor?.cp_prev_value}</>
    } else if (competitor?.cp_prev_value) {
        out = competitor?.cp_prev_value
    } else if (competitor?.cp_code) {
        out = <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} />
    }
    return (
        <div className='score-competitor-container  d-flex flex-row justify-content-start'>
            <div className='score-name'>
                {out}
            </div>
        </div>
    )
}

export function Footer({ data }) {

    const formatDate = Label({ data: 'BracketDateFormat' });
    const formatDateTime = Label({ data: 'BracketDateTimeFormat' });
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, TBD</>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode
    let isLive = isLiveStatus(data?.result?.status?.code);
    let isLessLive = isLessLiveStatus(data?.result?.status?.code);
    return (
        <>
            {isLive && <div className='score-status justify-content-end w-100'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex w-100">
                {isLessLive && <div className='text-start w-50'>{dateComponent ? dateComponent : 'TBD'}</div>}
                {isLessLive && <div className='text-end w-50'><Label data='HeaderMatch' /> {numberGame}</div>}
            </div>
        </>
    )
}



